/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * LLM data residency region for the organization (default GLOBAL)
 */
export type GetOrganizationSettings200LlmResidency =
  (typeof GetOrganizationSettings200LlmResidency)[keyof typeof GetOrganizationSettings200LlmResidency];

export const GetOrganizationSettings200LlmResidency = {
  GLOBAL: "GLOBAL",
  MONTREAL_CANADA: "MONTREAL_CANADA",
} as const;
